import { generateBooleanSchema, generateNumberSchema, generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("NV Play Match List", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  source: generateStringSchema("Source", "Use \"nvplay\" to connect to the NV Play Cloud."),
  days: generateNumberSchema("Days", "The number of days in the past to show matches for.", {
    defaultValue: 30,
  }),
  sortAscending: generateBooleanSchema("Sort Ascending", "Changes ordering to chronological based on start date."),
  pollSeconds: generateStringSchema("Poll Seconds", "The number of seconds to wait before refreshing data. If empty or 0, data will not update until the page is reloaded."),
}));
